import { loadTranslations } from '@ibk/shared-translation';
import enUS from './en-US.json';
import esES from './es-ES.json';
import ptBR from './pt-BR.json';
export const sharedUiTranslations = loadTranslations({
    'pt-BR': ptBR,
    'en-US': enUS,
    'es-ES': esES,
});
